import * as React from 'react';

interface IProps {
    title: string;
    labelId: string;
    children: React.ReactFragment;
    elementId: string | number;

    onClickFunction?(): void;
}

interface IState {
    isFolded: boolean;
}

class FoldableElement extends React.Component<IProps, IState> {

    constructor(props) {
        super(props);
        this.state = {
            isFolded: true
        }
    }

    private onLabelClick = () => {
        if (this.state.isFolded && this.props.onClickFunction) {
            this.props.onClickFunction();
        }
        this.setState({isFolded: !this.state.isFolded});
    }

    public componentDidUpdate(prevProps: Readonly<IProps>) {
        if (prevProps.elementId !== this.props.elementId) {
            this.setState({
                isFolded: true
            })
        }
    }

    public render() {
        const {title, labelId, children} = this.props;
        const {isFolded} = this.state;
        return <>
            <input type='checkbox' id={labelId} className='foldable__input' checked={!isFolded} readOnly/>
            <label htmlFor={labelId} className="heading foldable__head" onClick={this.onLabelClick}>
                {title}
                <img className='foldable__head-icon' src='/images/icons/arrow_left.svg' height={10}/>
            </label>

            <div className="flex foldable__element foldable__element--flex">
                {children}
            </div>
        </>
    }
}

export default FoldableElement;



// WEBPACK FOOTER //
// ./src/components/Layout/FoldableElement/FoldableElement.tsx